<router-outlet></router-outlet>

<div class="theme-toggle-container">
  <button mat-icon-button [matMenuTriggerFor]="themeMenu" class="theme-toggle-btn" matTooltip="Change Theme">
    <mat-icon>palette</mat-icon>
  </button>

  <mat-menu #themeMenu="matMenu">
    <button mat-menu-item *ngFor="let theme of themes" (click)="changeTheme(theme.id)">
      <mat-icon>circle</mat-icon>
      <span>{{ theme.displayName }}</span>
    </button>
  </mat-menu>
</div>